import { render, staticRenderFns } from "./author.vue?vue&type=template&id=c78acc06&scoped=true"
import script from "./author.vue?vue&type=script&lang=js"
export * from "./author.vue?vue&type=script&lang=js"
import style0 from "./author.vue?vue&type=style&index=0&id=c78acc06&prod&lang=scss&scoped=true"
import style1 from "./author.vue?vue&type=style&index=1&id=c78acc06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78acc06",
  null
  
)

export default component.exports